import { ReportsDataService } from './shared/reports-data.service';
import {
  Component,
  OnInit,
  ViewChild,
  TemplateRef,
  ViewEncapsulation,
  OnDestroy
} from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { FormGroup, FormControl, Validators, FormBuilder, FormArray } from '@angular/forms';
import {
  TramiteBase,
  DatosReporte,
  DatosReporteTarea,
  CategoriaReporte,
  Reporte,
  Filtro,
  BaseControl,
  ParametroFiltro,
  Container,
  TextArea,
  Textbox,
  Custom,
  DateTimePicker,
  Static,
} from '@app/shared';
import { TareaTramite } from '../shared/models/tarea.model';
import { result, Partial, find } from 'lodash';
import { Logger } from '@app/core';
import { ReportFormService } from './shared/reports.form.service';
import { ToastrService } from 'ngx-toastr';
import { SelectTramiteComponent } from '@app/shared/select-tramite/select-tramite.component';
import { Subject } from 'rxjs';
import { environment } from "@env/environment";
import { FlowService } from '@app/flow/shared/flow.service';
import { DatePipe } from "@angular/common";


// const log = new Logger('ReportsComponent');

@Component({
  selector: 'iw-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [FlowService, ReportsDataService, ReportFormService, DatePipe],

})
export class ReportsComponent implements OnInit, OnDestroy {
  // define cuando mostrar el texto de ayuda de el rango de fechas
  textInfo = false;
  // Define cuando esta cargando
  isLoading = false;
  // Contiene la lista de categorias de reportes
  categoryReportsDynamic: Array<CategoriaReporte> = [];
  // Contiene la lista de reportes dinamicos
  reportsDynamic: Array<Reporte> = [];
  // Contiene los filtros del reporte seleccionado
  reportsDynamicFilters: Filtro;
  // Contiene el tramite seleccionado
  tramite: TramiteBase;
  // Contiene las tareas del tramite
  taskTramite: Array<TareaTramite> = [];
  // Contiene los controles de el formulario de filtros de los reportes dinamicos
  controls: BaseControl<any>[] = [];
  // Referencia de la modal
  modalRef: BsModalRef;
  // Inicialisacion de fecha
  startAt: Date = new Date();
  // Contiene los templates de los controles personalizados
  templates = {};
  // Referencia al template de la modal
  @ViewChild('templateT') private template: TemplateRef<any>;
  @ViewChild('templateD') private templateD: TemplateRef<any>;
  @ViewChild('templateTareas') private templateTareas: TemplateRef<any>;
  // Referencia de el selector personalizado para los formularios
  @ViewChild('ngSelect') ngSelectTpl: TemplateRef<any>;
  // referencia de el selector de tramite
  @ViewChild('stcRef') stcRef: SelectTramiteComponent;
  // Formulario reporte tramite
  formRT: FormGroup = new FormGroup({
    dateRangeModal: new FormControl([this.startAt, this.startAt], [Validators.required]),
  });
  // Formulario reporte de tareas
  formRTarea: FormGroup = new FormGroup({
    dateRangeModal: new FormControl([this.startAt, this.startAt], [Validators.required]),
    SelectTarea: new FormControl(null, [Validators.required]),
  });
  // Formulario reportes dinamicos
  formRDynamic: FormGroup = new FormGroup({
    categoryReportDynamic: new FormControl(null, [Validators.required]),
    reportDynamic: new FormControl(null, [Validators.required]),
  });
  // Contiene el formulario de filtros
  formFilters: FormGroup;
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();

  //formulario reactivo para agregar filtros
  formulario: FormGroup;

  // controla si mostrar o no el mensaje deParámetros de búsqueda
  searchFilters: boolean = false;
  //modelo del selector de fecha final
  toDateSelector:any  = null;
  //modelo del selector de fecha inicial
  fromDateSelector:any = null;
  //modelo del selector de fecha
  selectedDate = '';
  // modelo para la selección del filtro de tipo en_lista
  selectedListItem: any = null;
  // Lista de parámetros que no han sido seleccionados para llena los selectores
  unselectedParameters: any[] = [];
  // Modelo para guardar la selección de los filtros
  selectedParameter: any[] = [];
  // Modelo para guardar los filtros
  selectorParameter: any[] = [];
  // define si se realiza la búsqueda por proceso
  searchByProcess: boolean = environment.searchByProcess;
  // lista de opciones para el filtro de tipo en_lista
  select_list: any[] = [];
  //Contiene la lista de parámetros para filtar por
  columnsSelect: any = {};
  dataTableModal: any = {};
  form: any = {};
  // form: FormGroup = new FormGroup({
  //   exampleModalSelect: new FormControl()
  // });
  // Lista de parámetros que nunca cambia
  noChangeParameters: any[] = [];

  constructor(private modalService: BsModalService,
    private rds: ReportsDataService,
    private toastr: ToastrService,
    private fb: FormBuilder,
    private fs: FlowService,
    private datePipe: DatePipe
  ) { }

  ngOnInit() {
    this.templates = {
      ngSelectTpl: this.ngSelectTpl,
    };
    this.toDateSelector  = null;
    this.fromDateSelector = null;
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
    this.form = {};
    this.columnsSelect = {};
    this.dataTableModal = {};
    this.toDateSelector  = null;
    this.fromDateSelector = null;
  }



  /**
   * Abre la modal con el formulario correspondiente
   *
   * @param {('trazabilidad' | 'tarea')} [type='trazabilidad'] // reporte a generar
   * @memberof ReportsComponent
   */
  open(type: 'trazabilidad' | 'tarea' | 'dinamico' = 'trazabilidad') {
    // Se abre la modal dependiendo de el tipo de reporte a abrir
    switch (type) {
      case 'tarea':
        this.modalRef = this.modalService.show(this.templateTareas, { class: 'modal-lg' });
        break;
      case 'dinamico':
        this.rds.getCategoryReport().subscribe(data => {
          this.categoryReportsDynamic = data;
        });

        this.formRDynamic.controls['categoryReportDynamic'].valueChanges.subscribe(data => {
          if (data) {
            this.rds.getReportsCategory(data).subscribe(category => {
              this.reportsDynamic = category.reportes;
              if (this.reportsDynamic && this.reportsDynamic.length) {
                this.reportsDynamic.forEach(report => {
                  report.nombre += ' - ' + report.codigo;
                });
              }
            });
          } else {
            this.reportsDynamic = [];
            this.controls = [];
            this.formFilters = null;
          }
          this.formRDynamic.controls['reportDynamic'].reset();
        });
        this.formRDynamic.controls['reportDynamic'].valueChanges.subscribe(data => {
          if (data) {
            //obtiene los filtros
            this.rds.getFiltersReports(data).subscribe(async filter => {

              if (filter.parametros.length) {
                this.reportsDynamicFilters = filter;
                //Obtiene controles
                this.controls = this.getFieldsFilterReportStructure(filter.parametros, this.templates);
                //Hace una copia de filter.parametros
                this.unselectedParameters = Static.copyObjet(filter.parametros);
                this.selectorParameter = Static.copyObjet(filter.parametros);
                
                //Pegar controles requeridos en la modal
                if(!this.formulario){
                  this.searchFilters = true;
                  
                  this.formulario = this.fb.group({
                    filtros: this.fb.array([]),
                  });
                  
                  this.selectorParameter.forEach(async (sp)=>{
                    if(sp.requerido == true){
            
                      let newform = this.createForm(sp.requerido, sp.tipo_campo.nombre);
                      let myFormArray = <FormArray>this.formulario.get("filtros");
                      newform.get("groupIndex").patchValue(myFormArray.length);
                      this.filtros.push(newform);
                      await this.initSelector(sp, newform.value.groupIndex);
                      this.formulario.controls.filtros['controls'][newform.value.groupIndex].selector = sp.id;
                      this.formulario.controls.filtros['controls'][newform.value.groupIndex].requerido = sp.requerido;
                      await this.onChangeState(sp,newform.value.groupIndex);
                    }
                  })
                }
              
              } else {
                this.reportsDynamicFilters = null;
                this.controls = [];
                this.formFilters = null;
              }
            });
          } else {
            this.reportsDynamicFilters = null;
            this.controls = [];
            this.formFilters = null;
          }
        });
        this.modalRef = this.modalService.show(this.templateD, { class: 'modal-personalized', backdrop: 'static', keyboard: false });

        break;
      default:
        this.modalRef = this.modalService.show(this.template, { class: 'modal-lg'});
        break;
    }
  }

  /**
   * Con la acción de swicthear el selector de reporte limpia el formulario
  */
  changeSelectedReport(){
    if (this.formulario){
      this.formulario.reset();
      this.formulario = null;
    }

    this.selectedParameter.length = 0;
    this.unselectedParameters.length = 0;
    this.reportsDynamicFilters = null;
  }
  

  /**
   * Genera el reporte y lo descarga de la ruta recibida
   *
   * @param {String} [type='trazabilidad']
   * @memberof ReportsComponent
   */
  async SendDTP(type: 'trazabilidad' | 'tarea' | 'dinamico' = 'trazabilidad') {
    let res: any, path: any = null;
    const form = type === 'tarea' ? this.formRTarea : this.formRT;
    const initialDate: Date = new Date(form.controls['dateRangeModal'].value[0]);
    const finalDate: Date = new Date(form.controls['dateRangeModal'].value[1]);
    this.isLoading = true;
    
    try {
      switch (type) {
        case 'tarea':
          const datos: DatosReporteTarea = {
            fecha_creacion: initialDate.toLocaleDateString(),
            fecha_finalizacion: finalDate.toLocaleDateString(),
            tramite: this.tramite.nombre,
            tarea: form.controls['SelectTarea'].value
          };
          res = await this.rds.getReportTask(datos.tarea, datos.tramite);
          path = result(res, 'path');
          if (path) {
            const a = document.createElement('a');
            a.target = '_blank';
            a.href = res.path;
            a.download = res.name;
            a.click();
            a.remove();
          }
          break;

        case 'dinamico':
          //Validacion de si tiene o no filtros
          if (this.reportsDynamicFilters == null && this.formulario == undefined) {
            //En caso de no tener
            if (this.formRDynamic.valid) {
              let filtrosR: any[] = [];
              
              res = await this.rds.generatedynamicReports(
                this.formRDynamic.controls['reportDynamic'].value,
                filtrosR
              );

              if (res !== false) {
                path = result(res, 'path');
                if (path) {
                  // log.debug(path);
                  const a = document.createElement('a');
                  a.target = '_blank';
                  a.href = res.path;
                  a.download = res.name;
                  a.click();
                  a.remove();
                }
              }
            }
            
          } else {
            let filtroR : any []= []; 
            if (this.controls) {
              //Verificaion de filtros
              if(this.filtros){
                
              let stateReq = true;
              
              let val: any = {};
              this.controls[0]['controls'].forEach(async (ctr: any) => {

                // Setear valor del id
                let parametroAct = find(this.reportsDynamicFilters.parametros, { id: ctr.key });
                
                // Obtener seleccionadp
                let parametroSel = find(this.selectedParameter, { id: ctr.key });

                // Obtener informacion
                //let parametroInfo = find(this.filtros.value, { selector: ctr.key });
                               
                this.filtros.value.forEach((f: any) => {
                    
                  if(f.selector == ctr.key && parametroAct.tipo_campo.nombre !== 'selector' &&  parametroAct.tipo_campo.nombre !== 'rango_fechas' && parametroAct.tipo_campo.nombre !== 'fecha'){                      
                    val['valor'] = f.filtro;
                    
                  }else if(f.selector == ctr.key && parametroAct.tipo_campo.nombre == 'selector'){                    
                    val['valor'] = f.filtro.id;
                    
                  }else if(f.selector == ctr.key && parametroAct.tipo_campo.nombre == 'rango_fechas'){
                    val['valor'] = {};
                    val['valor']['fecha_inicial'] = this.datePipe.transform(this.fromDateSelector, 'yyyy-MM-dd');
                    val['valor']['fecha_final'] = this.datePipe.transform(this.toDateSelector, 'yyyy-MM-dd');
                    
  
                  } else if(f.selector == ctr.key && parametroAct.tipo_campo.nombre == 'fecha'){                    
                    val['valor'] = this.datePipe.transform(this.selectedDate, 'yyyy-MM-dd'); 
                  }
                });
                
                if (parametroSel && val && (val.valor == '' || val.valor == undefined)) {
                  
                  stateReq = false;
                  this.toastr.warning('Asegúrese de llenar todos los campos requeridos e intentelo de nuevo');
                  
                } else if(parametroAct.tipo_campo.nombre == 'rango_fechas' && parametroSel && parametroSel.tipo_campo.nombre == 'rango_fechas') {
                  
                  if(parametroSel && val.valor.fecha_inicial == null || val.valor.fecha_final == null){
                    stateReq = false;
                    this.toastr.warning('Asegúrese de llenar todos los campos requeridos e intentelo de nuevo');
                  
                  }
                }
                
              })
              
              if(stateReq ){ 
                this.reportsDynamicFilters.parametros.forEach(pl=>{                 
                  this.filtros.value.forEach((f: any) => {
                    if(f.selector == pl.id && pl.tipo_campo.nombre !== 'selector' &&  pl.tipo_campo.nombre !== 'rango_fechas' && pl.tipo_campo.nombre !== 'fecha'){
                      let val = {};
                      val['id'] = pl.id;
                      val['alias'] = pl.alias;
                      val['valor'] = f.filtro;
                      filtroR.push(val);
                      
                    }else if(f.selector == pl.id && pl.tipo_campo.nombre == 'selector'){
                      let val = {};
                      val['id'] = pl.id;
                      val['alias'] = pl.alias;
                      val['valor'] = f.filtro.id;
                      filtroR.push(val);
                      
                    }else if(f.selector == pl.id && pl.tipo_campo.nombre == 'rango_fechas'){
                      let val = {};
                      val['id'] = pl.id;
                      val['alias'] = pl.alias;
                      val['valor'] = {};
                      val['valor']['fecha_inicial'] = this.datePipe.transform(this.fromDateSelector, 'yyyy-MM-dd');
                      val['valor']['fecha_final'] = this.datePipe.transform(this.toDateSelector, 'yyyy-MM-dd');
                      filtroR.push(val);
    
                    } else if(f.selector == pl.id && pl.tipo_campo.nombre == 'fecha'){
                      let val = {};
                      val['id'] = pl.id;
                      val['alias'] = pl.alias;
                      val['valor'] = this.datePipe.transform(this.selectedDate, 'yyyy-MM-dd');
                      filtroR.push(val);
                  
                    }
                  })
                })
                res = await this.rds.generatedynamicReports(
                  this.formRDynamic.controls['reportDynamic'].value, filtroR
                );
              } else if(stateReq && !this.filtros){
                this.toastr.warning('Selecciona el filtro para realizar el reporte');
                
              }
            } else {
              //this.toastr.error('Por favor selecciona el filtro')
              res = await this.rds.generatedynamicReports(
                this.formRDynamic.controls['reportDynamic'].value, filtroR
              );
            }

            if (res !== false) {
              path = result(res, 'path');
              if (path) {
                // log.debug(path);
                const a = document.createElement('a');
                a.target = '_blank';
                a.href = res.path;
                a.download = res.name;
                a.click();
                a.remove();
              }
            }
              
            }
          }

          break;

        default:
          const datosTramite: DatosReporte = {
            fecha_creacion: initialDate.toLocaleDateString(),
            fecha_finalizacion: finalDate.toLocaleDateString(),
            tramite: this.tramite.id,
          };
          res = await this.rds.getReportTraceability(
            datosTramite.tramite,
            datosTramite.fecha_creacion,
            datosTramite.fecha_finalizacion
          );
          path = result(res, 'path');
          if (path) {
            const a = document.createElement('a');
            a.target = '_blank';
            a.href = res.path;
            a.download = res.name;
            a.click();
            a.remove();
          }
          break;
      }
    } catch (error) {
      // log.error('Error al realizar el reporte:', error);
    }
    this.isLoading = false;
  }


  /**
   * Carga las tareas del tramite predeterminado seleccionado
   *
   * @param {*} data
   * @param {String} [type='trazabilidad']
   * @memberof ReportsComponent
   */
  loadingTask(data: any, type: String = 'trazabilidad') {
    if (data) {
      this.tramite = data;
      if (type === 'tarea') {
        this.rds.getTaskTramiteDefault(this.tramite.id).subscribe(task => {
          this.taskTramite = task;
        });
      }
    }
  }

  /**
   * Encapsula el formulario de los filtros del reporte
   *
   * @param {FormGroup} form
   * @memberof ReportsComponent
   */
  formCreateFilters(form: FormGroup) {
    this.formFilters = form;
  }

  /*Requerimiento 3 por Mauricio Quiñones*/

  requiredControls() {
    //Busqueda para eliminar los formularios requeridos de la variable unselectedParameters y se añade a selectedParameter
    for (var i = 0; i <= this.controls.length; i++) {
      if (this.unselectedParameters[i].requerido == true) {
        this.selectedParameter.push(this.unselectedParameters[i]);
        this.unselectedParameters.splice(i, 1);
      }
    }
  }


  /**
   *Retorna un formulario con la estructura necesaria de los filtros
   *
   * @return {*}
   * @memberof ReportsComponent
   */
  createForm(requerido?: boolean, filtro?: string) {
    return this.fb.group({
      groupIndex: "",
      selector: "",
      filtro: new FormControl(''),
      minDate: "",
      maxDate: "",
      enable: false,
      tipo_filtro: filtro ? filtro : 'text',
      class: '',
      label_selector: [],
      requerido: requerido,
    });
  }


  /**
   *Obtiene los formularios de los filtros
   *
   * @readonly
   * @type {FormArray}
   * @memberof ReportsComponent
   */
  get filtros(): FormArray {
    return this.formulario ? this.formulario.get("filtros") ? this.formulario.get("filtros") as FormArray : null : null;
  }


  crearFormulario() {
    this.formulario = this.fb.group({
      filtros: this.fb.array([]),
    });
    const newform = this.createForm();
    const myFormArray = <FormArray>this.formulario.get("filtros");
    newform.get("groupIndex").patchValue(myFormArray.length);
    this.filtros.push(newform);
  }

  /**
   *Añade un formulario de filtro
   *
   * @memberof ReportsComponent
   */
  addFilter() {
    if (this.unselectedParameters.length) {
      this.selectorParameter.forEach(sp => {
        if (sp.requerido) {
          let paramSelect = find(this.unselectedParameters, {'alias' : sp.alias })
          var posicion = this.unselectedParameters.indexOf(paramSelect)
          if (posicion != -1) {
            this.unselectedParameters.splice(posicion, 1)
          }
        }
      })
    }
    
    if (!this.formulario) {
      this.searchFilters = true;
      this.crearFormulario();

    } else {
      let valid: boolean = true;

      this.filtros.value.forEach((filter: any) => {

        if ((filter.filtro === "" && filter.tipo_filtro !== 'rango_fechas' && filter.tipo_filtro !== 'en_lista' && filter.tipo_filtro !== 'fecha') || filter.selector === undefined || filter.selector === null) {
          valid = false;
        }
        if ((filter.tipo_filtro == 'rango_fechas' && this.toDateSelector == '' && this.fromDateSelector == '')) {
          valid = false;
        }
        if ((filter.tipo_filtro == 'en_lista' && this.selectedListItem == null)) {
          valid = false;
        }
        if ((filter.tipo_filtro == 'fecha' && this.selectedDate == '')) {
          valid = false;
        }
      });

      if (!valid) {
        this.toastr.warning("Debe llenar todos los campos", "Error en la acción");
      } else {
        if (this.unselectedParameters.length) {
          const newform = this.createForm();
          const myFormArray = <FormArray>this.formulario.get("filtros");
          newform.get("groupIndex").patchValue(myFormArray.length);
          this.filtros.push(newform);
        } else {
          this.toastr.warning("No hay más parámetros de búsqueda", "Error en la acción");
        }
      }
    }
  }

  /**
 *Elimina un formulario de filtro
 *
 * @param {number} indice
 * @memberof ReportsComponent
 */
  deleteFilter(indice: number) {
    if (this.filtros.value[indice].selector !== undefined) {
      if (this.filtros.value[indice].tipo_filtro == 'fecha') {
        this.selectedDate = '';
      }
      if (this.filtros.value[indice].tipo_filtro == 'rango_fechas') {
        this.fromDateSelector = null;
        this.toDateSelector = null;
      }
      if (this.filtros.value[indice].tipo_filtro == 'en_lista') {
        this.selectedListItem = null;
      }
      if (this.selectedParameter.length) {
        let index = 0;
        let exist = false;
        this.selectedParameter.forEach((sp, i) => {
          if (sp['index'] == indice) {
            index = i;
            exist = true;
          }
        })
        if (exist) {
          this.selectedParameter.splice(index, 1);
          if (this.selectedParameter.length) {
            this.selectedParameter.forEach(slctp => {
              if (slctp['index'] >= indice) {
                slctp.index = slctp.index - 1;
              }
            });
          }
        }
        //agregar a unselectedParameters lo que hay en selectedParameter
        let itemResult = find(this.selectorParameter, {id: this.filtros.value[indice].selector})
        this.unselectedParameters.push(itemResult);

        //Le asignamos a unselectedParameters una copia de lo que getFiltersReports nos entrega, asi cuando se agregue un filtro "this.filtros" estara limpia
        //this.unselectedParameters = Static.copyObjet(this.reportsDynamicFilters.parametros);
        this.unselectedParameters = [...this.unselectedParameters];

        let enable: boolean;
        this.noChangeParameters.forEach(ncp => {
          enable = true;
          this.selectedParameter.forEach(sp => {
            if (sp.id == ncp.id) {
              enable = false
            }
          })
          if (enable) {
            this.unselectedParameters = [...this.unselectedParameters, ncp]
          }
        })
      }
    }
    if(this.dataTableModal[indice]){
      delete this.dataTableModal[indice];
    }
    if(this.columnsSelect[indice]){
      delete this.columnsSelect[indice];
    }
    if(this.form[indice]){
      delete this.form[indice];
    }
    this.filtros.removeAt(indice);
  }



  /**
   * Crea el formulario dinamico de los filtros del reporte
   *
   * @param {ParametroFiltro[]} columns
   * @param {*} templetesForm
   * @returns {BaseControl<any>[]}
   * @memberof FlowFormService
   */
  getFieldsFilterReportStructure(
    columns: ParametroFiltro[],
    templetesForm: any
  ): BaseControl<any>[] {

    const controls: BaseControl<any>[] = [new Container({
      class: 'form-row form-check form-check-inline col-12',
      order: 1,
      controls: []
    })];

    columns.forEach(field => {
      controls[0]['controls'].push(this.getControl(field, templetesForm));
    });

    return controls.sort((a, b) => a.order - b.order);
  }


  /**
   * Crea el control de pendiendo del tipo
   *
   * @param {ParametroFiltro} control
   * @param {*} templetesFomr
   * @param {*} [value]
   * @returns {BaseControl<Partial>}
   * @memberof FlowFormService
   */
  private getControl(
    control: ParametroFiltro,
    templetesFomr: any,
  ): BaseControl<Partial> {
    let field: any;
    switch (control.tipo_campo.nombre) {
      case 'textarea':
        const textArea: TextArea = new TextArea({
          key: control.id,
          label: control.label,
          size: 'col-md-' + control.espacio,
          rows: '4',
          placeholder: control.label,
          value: null,
          order: control.orden,
          validations: {
            validators: [],
            messages: {}
          },
        });
        if (control.requerido) {
          textArea.validations.validators.push(Validators.required);
        }

        field = textArea;
        break;
      case 'email':
        const email: Textbox = new Textbox({
          key: control.id,
          label: control.label,
          type: control.tipo_campo.nombre,
          value: null,
          order: control.orden,
          placeholder: control.label,
          size: 'col-md-' + control.espacio,
          validations: {
            validators: [Validators.pattern(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/)],
            messages: {
              email: 'Por favor introduce un email válido.'
            }
          },
        });
        if (control.requerido) {
          email.validations.validators.push(Validators.required);
        }

        field = email;
        break;
      case 'date-time-picker':
        const date: DateTimePicker = new DateTimePicker({
          key: control.id,
          label: control.label,
          order: control.orden,
          value: null,
          size: 'col-md-' + control.espacio,
          pickerMode: 'dialog',
          placeholder: control.label,
          pickerType: 'calendar',
          validations: {
            validators: [],
            messages: {}
          },
        });
        if (control.requerido) {
          date.validations.validators.push(Validators.required);
        }
        // Queda pendiente por definir la estructura
        // switch (control.propiedades['tipo']) {
        //   case 'calendar':
        //     date.pickerType = 'calendar';
        //     break;
        //   case 'timer':
        //     date.pickerType = 'timer';
        //     break;
        //   case 'range':
        //     date.selectMode = 'range';
        //     break;
        //   case 'rangeTime':
        //     date.pickerType = 'timer';
        //     date.selectMode = 'range';
        //     break;
        //   case 'rangeDate':
        //     date.pickerType = 'calendar';
        //     date.selectMode = 'range';
        //     break;
        // }
        field = date;
        break;
      case 'ngSelect':
        const ngSelect: Custom = new Custom({
          key: control.id,
          label: control.label,
          order: control.orden,
          size: 'col-md-' + control.espacio,
          template: templetesFomr.ngSelectTpl,
          placeholder: control.label,
          value: null,
          options: control['options'] ? control['options'] : [],
          validations: {
            validators: [],
            messages: {}
          },
        });
        if (control.requerido) {
          ngSelect.validations.validators.push(Validators.required);
        }
        field = ngSelect;
        break;
      case 'number':
        const number: Textbox = new Textbox({
          key: control.id,
          label: control.label,
          type: control.tipo_campo.nombre,
          value: null,
          order: control.orden + 1,
          placeholder: control.label,
          size: 'col-md-' + control.espacio,
          validations: {
            validators: [],
            messages: {}
          },
        });
        if (control.requerido) {
          number.validations.validators.push(Validators.required);
        }

        field = number;
        break;
      default:
        const text: Textbox = new Textbox({
          key: control.id,
          label: control.label,
          type: control.tipo_campo.nombre,
          value: null,
          order: control.orden + 1,
          placeholder: control.label,
          size: 'col-md-' + control.espacio,
          validations: {
            validators: [],
            messages: {}
          },
        });
        if (control.requerido) {
          text.validations.validators.push(Validators.required);
        }

        field = text;
        break;
    }
    return field;
  }

  /**
 *Controla que las opciones de los selectores no se dupliquen
 *
 * @param {*} data
 * @param {number} index
 * @memberof ReportsComponent
 */
  async onChangeState(data: any, index: number) {
    if (data !== undefined) {
      //if(data.tipo_estructura.nombre == 'selector'){  cambio de tipo_esturctura a tipo_campo
      if (data.tipo_campo.nombre == 'selector') {
        await this.fs.getList(data.sub_structura.nombre_servicio).then(async res => {
          if (res) {
            this.select_list = await res;
            if(this.dataTableModal){
              this.dataTableModal[index] = res;
            }
            
            // this.dataTableModal = await res;
          }
        }, err => {

        })
      }
      data['groupIndex'] = this.filtros.value[index].groupIndex;

      this.formulario.controls.filtros['controls'][index].patchValue({ enable: true });

      this.filtros.value[index].tipo_filtro = data.tipo_campo.nombre;
      if (this.filtros.value[index].tipo_filtro == 'selector') {
        this.form[index] = new FormGroup({
          exampleModalSelect: new FormControl()
        });
        if (data && data.espacio && data.espacio < 9) {
          this.filtros.value[index].class = 'container ml-0 mr-0 col-' + data.espacio
        } else if (data && data.espacio) {
          this.filtros.value[index].class = 'container ml-0 mt-1 mr-0 col-' + data.espacio
        }
        this.columnsSelect[index] = data.sub_structura.estructura_modal
        this.filtros.value[index].label_selector = data.sub_structura.labels_selector;
        this.columnsSelect[index].sort(function (a: { orden: number; }, b: { orden: number; }) {
          if (a.orden > b.orden) {
            return 1;
          }
          if (a.orden < b.orden) {
            return -1;
          }
          return 0;
        });
      } else if (this.filtros.value[index].tipo_filtro == 'texto') {

        if (data && data.espacio && data.espacio < 9) {
          this.filtros.value[index].class = await 'form-control col-' + data.espacio
        } else if (data && data.espacio) {
          this.filtros.value[index].class = await 'form-control mt-1 col-' + data.espacio
        }
      } else if (this.filtros.value[index].tipo_filtro == 'rango_fechas') {
        if (data && data.espacio && data.espacio < 9) {
          this.filtros.value[index].class = await 'input-group mb-2 pd-0 col-' + data.espacio
        } else if (data && data.espacio) {
          this.filtros.value[index].class = await 'input-group mb-2 mt-2 pd-0 col-' + data.espacio
        }
      }
      let item = data;
      let exist = false;
      let spIndex = 0;
      item['index'] = index;
      this.selectedParameter.forEach((sp, i) => {
        if (sp['index'] == item['index']) {
          spIndex = i;
          exist = true
        }
      })
      
      if (exist) {
        //Cambiamos tipo_estructura por tipo_campo
        if (this.selectedParameter[spIndex].tipo_campo.nombre == 'rango_fechas') {
          this.toDateSelector = null;
          this.fromDateSelector = null;
        } else if (this.selectedParameter[spIndex].tipo_campo.nombre == 'modal') {
          this.filtros.value[index].filtro = null;
          this.form[index] = new FormGroup({
            exampleModalSelect: new FormControl()
          });
        }
        this.selectedParameter.splice(spIndex, 1, item);
      } else {
        this.selectedParameter.push(item);
        var posicion = this.unselectedParameters.indexOf(item)
        this.unselectedParameters.splice(posicion, 1)
      }

      //le reasignamos el valor de unselectedParameters para que tome los valores limpios del inicio 
      //this.unselectedParameters = Static.copyObjet(this.reportsDynamicFilters.parametros);
      this.unselectedParameters = [...this.unselectedParameters];

      let enable: boolean;
      this.noChangeParameters.forEach(ncp => {
        enable = true;
        this.selectedParameter.forEach(sp => {
          if (sp.id == ncp.id) {
            enable = false
          }
        })
        if (enable) {
        }
      })
    }

  }

  changeSelection(data: any, filter: any, index: any) {
    if (data !== null) {
      let resultData = this.dataTableModal[index];
      if (resultData){
        resultData.forEach((d: { id: any; }) => {
        if (d.id == data.id) {
          filter.value.filtro = data;
        }
      });
      }  
    }
  }

  changeColumns(data: any) {
    this.selectedParameter.forEach(async sp => {
      if (sp['index'] == data) {
        this.columnsSelect[data] = await sp.sub_structura.estructura_modal;
        // this.columnsSelect = await [...this.columnsSelect];
      }
    })
  }

  async initSelector(data: any, index: number) {
    if (data !== undefined) {
      //if(data.tipo_estructura.nombre == 'selector'){  cambio de tipo_esturctura a tipo_campo
      if (data.tipo_campo.nombre == 'selector') {

        await this.fs.getList(data.sub_structura.nombre_servicio).then(async res => {
          if (res) {
            this.select_list = await res;
            if(this.dataTableModal){
              this.dataTableModal[index] = res;
            }
            // this.dataTableModal = await res;
          }
        }, err => {

        })
      }
      data['groupIndex'] = this.filtros.value[index].groupIndex;

      this.formulario.controls.filtros['controls'][index].patchValue({ enable: true });

      this.filtros.value[index].tipo_filtro = data.tipo_campo.nombre;
      if (this.filtros.value[index].tipo_filtro == 'selector') {
        this.form[index] = new FormGroup({
          exampleModalSelect: new FormControl()
        });
        if (data && data.espacio && data.espacio < 9) {
          this.filtros.value[index].class = 'container ml-0 mr-0 col-' + data.espacio
        } else if (data && data.espacio) {
          this.filtros.value[index].class = 'container ml-0 mt-1 mr-0 col-' + data.espacio
        }
        this.columnsSelect[index] = data.sub_structura.estructura_modal
        this.filtros.value[index].label_selector = data.sub_structura.labels_selector;
        this.columnsSelect[index].sort(function (a: { orden: number; }, b: { orden: number; }) {
          if (a.orden > b.orden) {
            return 1;
          }
          if (a.orden < b.orden) {
            return -1;
          }
          return 0;
        });
      } else if (this.filtros.value[index].tipo_filtro == 'texto') {
        if (data && data.espacio && data.espacio < 9) {
          this.filtros.value[index].class = await 'form-control col-' + data.espacio
        } else if (data && data.espacio) {
          this.filtros.value[index].class = await 'form-control mt-1 col-' + data.espacio
        }
      } else if (this.filtros.value[index].tipo_filtro == 'rango_fechas') {
        if (data && data.espacio && data.espacio < 9) {
          this.filtros.value[index].class = await 'input-group mb-2 pd-0 col-' + data.espacio
        } else if (data && data.espacio) {
          this.filtros.value[index].class = await 'input-group mb-2 mt-2 pd-0 col-' + data.espacio
        }
      }
      let item = data;
      let exist = false;
      let spIndex = 0;
      item['index'] = index;
      this.selectedParameter.forEach((sp, i) => {
        if (sp['index'] == item['index']) {
          spIndex = i;
          exist = true
        }
      })
      if (exist) {
        if (this.selectedParameter[spIndex].tipo_estructura.nombre == 'rango') {
          this.toDateSelector = null;
          this.fromDateSelector = null;
        } else if (this.selectedParameter[spIndex].tipo_estructura.nombre == 'modal') {
          this.filtros.value[index].filtro = null;
          this.form[index] = new FormGroup({
            exampleModalSelect: new FormControl()
          });
        } 
        this.selectedParameter.splice(spIndex, 1, item);
      } else {
        this.selectedParameter.push(item);
      }

      //le reasignamos el valor de unselectedParameters para que tome los valores limpios del inicio 
      //this.unselectedParameters = Static.copyObjet(this.reportsDynamicFilters.parametros);
      this.unselectedParameters = [...this.unselectedParameters];

      let enable: boolean;
      this.noChangeParameters.forEach(ncp => {
        enable = true;
        this.selectedParameter.forEach(sp => {
          if (sp.id == ncp.id) {
            enable = false
          }
        })
        if (enable) {
          //this.unselectedParameters = [...this.unselectedParameters, ncp]
        }
      })
    }
  }

  // Metodo para limpiar los controles al cerrar la modal
  clear(value: any): void {
    this.formRDynamic.reset();
    this.formRDynamic = new FormGroup({
      categoryReportDynamic: new FormControl(null, [Validators.required]),
      reportDynamic: new FormControl(null, [Validators.required]),
    });
    if (this.formulario){
        this.formulario.reset();
        this.formulario = null;
    }
    if (this.filtros && this.filtros.controls){
      this.filtros.controls = [];
    }
    this.form = {};
    this.columnsSelect = {};
    this.dataTableModal = {};
    this.toDateSelector  = null;
    this.fromDateSelector = null;
  }
}

function exampleModalSelect(exampleModalSelect: any) {
  throw new Error('Function not implemented.');
}


// WEBPACK FOOTER //
// ./src/app/reports/reports.component.ts